'use client'
import React from 'react'
import { useState } from 'react'
import {ChevronUpIcon, ChevronDownIcon} from '@heroicons/react/24/outline'
import logo from '../assets/images/logos/fluidos_tecnicos_logo.png'
import { FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt, FaMapSigns, FaHardHat, FaEnvelope} from 'react-icons/fa';

export default function PageInConstructionBody() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  return (
    <div className="bg-gradient-to-b from-[#0F3E69] to-[#5B8898] flex flex-col">
        <header id='initial-header'>
            <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-center lg:px-8">
                <div className="flex items-center justify-center">
                    <img
                        alt=""
                        src={logo}
                        className="h-auto w-auto"
                        />
                </div>
            </nav>
        </header>

        <section className="min-h-screen" id='initial-section'>
            <div className="max-w-7xl mx-auto px-6 lg:px-8 text-white">
                <h2 className="text-4xl font-bold text-center leading-tight flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                    <FaHardHat className="text-4xl" />
                    <span className="font-mono">Sitio en construcción</span>
                </h2>
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-8 text-white" style={{ marginTop: '15%' }}>
                <h2 className="text-3xl font-semibold text-center leading-tight flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                    <span className="font-mono">Contactate</span>
                </h2>
            </div>

            <div className="flex justify-center">
                <button
                onClick={() =>
                document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' })
                }
                className="mt-2 flex items-center justify-center text-white hover:text-gray-300 ">
                <ChevronDownIcon className="h-16 w-16" />
            </button>
            </div>
        </section>

        <section id='contact-section'className="py-10 min-h-screen">

            <div className="flex justify-center">
                <button onClick={() =>
                document.getElementById('initial-header').scrollIntoView({ behavior: 'smooth' })
                }
                className="mb-12 flex items-center justify-center text-white hover:text-gray-300">
                <ChevronUpIcon className="h-16 w-16" />
            </button>
            </div>
            <div className="max-w-7xl mx-auto px-6 lg:px-8 text-white">
                <h2 className="text-4xl font-extrabold text-center leading-tight">
                Contacto
                </h2>
                <p className="mt-4 text-center text-lg opacity-80">
                ¡Estamos aquí para ayudarte! No dudes en contactarnos.
                </p>
                <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
                    <h3 className="text-xl font-semibold text-gray-900">Dirección</h3>
                    <p className="mt-2 text-gray-600 flex items-center">
                        <FaMapSigns className="mr-2" /> Estanislao Zeballos 1052
                    </p>
                    <p className="mt-2 text-gray-600 flex items-center">
                        <FaMapMarkerAlt className="mr-2" /> Pilar - Buenos Aires - Argentina
                    </p>
                </div>
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300">
                    <h3 className="text-xl font-semibold text-gray-900">Teléfonos</h3>
                    <p className="mt-2 text-gray-600 flex items-center">
                        <FaPhoneAlt className="mr-2" /> 0230 423 3416
                    </p>
                    <p className="mt-2 text-gray-600 flex items-center">
                        <FaWhatsapp className="mr-2" /> 
                        <a 
                            href="https://wa.me/5491136448859" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="hover:text-green-700"
                        > +54 911 3644 8859 </a>
                    </p>
                </div>
                <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 sm:col-span-2 lg:col-span-1">
                    <h3 className="text-xl font-semibold text-gray-900">Correo Electrónico</h3>
                    
                    <div className="flex items-center text-blue-500 mt-2">
                        <FaEnvelope className="mr-2 text-gray-600"/>
                        <a href="mailto:info@fluidostecnicos.com">info@fluidostecnicos.com</a>
                    </div>

                    <div className="flex items-center text-blue-500 mt-2">
                        <FaEnvelope className="mr-2 text-gray-600"/>
                        <a href="mailto:ventas@fluidostecnicos.com">ventas@fluidostecnicos.com</a>
                    </div>
                </div>
                </div>
            </div>
        </section>

        <div className="flex flex-col">
            <footer className="text-white py-4 mt-auto">
                <div className="max-w-7xl mx-auto text-center">
                <p>&copy; 2024 Fluidos Técnicos. Todos los derechos reservados.</p>
                </div>
            </footer>
        </div>
    </div>
  )
}
